import { Injectable } from '@angular/core';
import { Resolve } from '@angular/router';
import { Store } from '@ngrx/store';
import { filter, take } from 'rxjs/operators';
import { GetCustomerOptionsRequest } from '../../State/actions/mdqx/customer-options.actions';
import { getCustomerOptionsFetched } from '../../State/selectors/mdqx/selectors';
import { State } from '../../State';


@Injectable({
    providedIn: 'root'
})
export class CustomerOptionsResolver implements Resolve<boolean> {
    constructor(private store: Store<State>) {}

    resolve() {
        const value$ = this.store.select(getCustomerOptionsFetched);

        value$
            .pipe(take(1))
            .subscribe(
                fetched =>
                    !fetched &&
                    localStorage.getItem('token') != null &&
                    this.store.dispatch(new GetCustomerOptionsRequest())
            );

        return value$.pipe(
            filter(v => v),
            take(1)
        );
    }
}
